const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '实时更新',
    desc: '7×24小时全天候追踪全网娱乐动态，第一时间推送最新吃瓜视频与黑料，绝不错过任何热门话题。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    id: 2,
    icon: 'ri-global-line',
    title: '全网覆盖',
    desc: '聚合微博、抖音、小红书、豆瓣等多平台内容，一个入口看遍全网吃瓜资源，51吃瓜网站让你一站吃透。',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '安全直连',
    desc: '51吃瓜网址采用安全加密连接，无弹窗广告干扰，纯净浏览体验，让你安心吃瓜不迷路。',
    color: 'bg-secondary-100 text-secondary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            51吃瓜网站为什么是全网最好的吃瓜入口？三大优势带你了解
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="text-center p-6 md:p-8 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200/60 transition-all duration-300"
            >
              <div className={`w-16 h-16 flex items-center justify-center mx-auto mb-5 rounded-2xl ${feature.color}`}>
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}